// extracted by mini-css-extract-plugin
module.exports = {"container":"BoxChip_container__WqXEN"};